import React from 'react';

import * as S from './Spinner.styles';

const Spinner = ({
  width = '60px',
  height = '60px',
  borderWidth = '8px',
}) => {
  return (
    <S.Spnr width={width} height={height} borderWidth={borderWidth}></S.Spnr>
  )
}

export default Spinner;